import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {createPortal} from 'react-dom';
import {CSSTransition} from 'react-transition-group';

import ModalMask from '@stubhub/react-modal-mask';

import './index.scss';

const ScrimBackground = ({enabled, timeout, children}) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient
    ? createPortal(
        <CSSTransition in={enabled} classNames="ScrimBackground" unmountOnExit timeout={timeout}>
          <ModalMask>{children}</ModalMask>
        </CSSTransition>,
        document.body
      )
    : null;
};

ScrimBackground.propTypes = {
  enabled: PropTypes.bool.isRequired,
  timeout: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};

ScrimBackground.defaultProps = {
  timeout: 500,
};

export default ScrimBackground;
